"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/tag/tag");
/**
 * <mm-timeline-item>
 * 시점을 태그로 앞세우고 그 아래 그 시점의 기록을 쌓는 이력 한 칸입니다.
 */
let TimelineItem = class TimelineItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'listitem');
    }
    render() {
        return (0, lit_1.html) `
      <mm-tag>${this.label}</mm-tag>
      <slot></slot>
    `;
    }
};
TimelineItem.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }

    /* 행에 딸린 세부 목록은 행의 글자 자리에 맞춰 들여쓴다. */
    ::slotted(mm-text-list) {
      margin-left: calc(var(--size-40) + var(--space-2));
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TimelineItem.prototype, "label", void 0);
TimelineItem = __decorate([
    (0, decorators_js_1.customElement)('mm-timeline-item')
], TimelineItem);
exports.TimelineItem = TimelineItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZWxpbmUtaXRlbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRpbWVsaW5lLWl0ZW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUUzRCx1Q0FBb0M7QUFFcEM7OztHQUdHO0FBRUksSUFBTSxZQUFZLEdBQWxCLE1BQU0sWUFBYSxTQUFRLGdCQUFVO0lBQXJDOztRQWF1QixVQUFLLEdBQUcsRUFBRSxDQUFBO0lBYXhDLENBQUM7SUFYQyxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxVQUFVLENBQUMsQ0FBQTtJQUN2QyxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7Z0JBQ0MsSUFBSSxDQUFDLEtBQUs7O0tBRXJCLENBQUE7SUFDSCxDQUFDOztBQXhCTSxtQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7OztHQVdsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzsyQ0FBVztBQWIzQixZQUFZO0lBRHhCLElBQUEsNkJBQWEsRUFBQyxrQkFBa0IsQ0FBQztHQUNyQixZQUFZLENBMEJ4QjtBQTFCWSxvQ0FBWSJ9